import Vue from 'vue'
import * as types from '../mutation-types'

// initial state
const state = {
  globalsLocked: false
}

// getters
const getters = {
  globalsLocked: state => state.globalsLocked
}

// actions
const actions = {
  lockScreen ({ state, commit }) {
    let value = true
    commit(types.GLOBALS_SET_LOCKED, { value })
  },
  unlockScreen ({ state, commit }) {
    let value = false
    commit(types.GLOBALS_SET_LOCKED, value )
  }
}

// mutations
const mutations = {
  [types.GLOBALS_SET_LOCKED] (state, value) {
    console.log('GLOBALS_SET_LOCKED', value)
    state.globalsLocked = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
